module.exports = __webpack_public_path__ + "static/media/app-store-badge.a587f2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/app-store-badge.png
// module id = 272
// module chunks = 0